import { Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
  selector: 'twino-halvo-application-layout',
  templateUrl: './halvo-application-layout.component.html',
  styleUrls: ['./halvo-application-layout.component.scss']
})
export class HalvoApplicationLayoutComponent  {}
